// src/components/Dashboard/RoleDashboard/VSNTransfers.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Reuse the existing Agent CSS so it looks the same
import "../AgentDashboard/VSNtransfersAgent.css";

const VSNTransfers = ({ role, userId }) => {
    // 🔁 Rename tab state value to Watchlist
    const [activeTab, setActiveTab] = useState("Contract Offers");
    const navigate = useNavigate();

    // Normalize role and keep it safe
    const normalizedRole = (role || "agent").toLowerCase();
    const rolePrefix = ["agent", "scout", "club"].includes(normalizedRole)
        ? normalizedRole
        : "agent";

    useEffect(() => {
        console.log("🧭 VSNTransfers received:", {
            role: normalizedRole,
            userId,
        });
    }, [normalizedRole, userId]);

    // 🔁 Navigate into /{role}-dashboard/{subPath}
    const handleTabClick = (tabName, subPath) => {
        const base = `/${rolePrefix}-dashboard`;
        const path = `${base}/${subPath}`;

        console.log("➡️ Navigating to:", path, {
            role: normalizedRole,
            userId,
        });

        setActiveTab(tabName);
        navigate(path, {
            state: {
                userId,
                role: normalizedRole,
            },
        });
    };

    return (
        <div className="vsn-wrapper">
            <div className="vsn-transfers">
                <h3 className="vsn-title">VSN Transfers</h3>

                <div className="vsn-button-stack">
                    {/* Contract Offers */}
                    <button
                        className={activeTab === "Contract Offers" ? "active" : ""}
                        onClick={() =>
                            handleTabClick("Contract Offers", "contract-offer")
                        }
                    >
                        Contract Offers
                    </button>

                    {/* 🔥 Watchlist (formerly Show Interest) */}
                    <button
                        className={activeTab === "Watchlist" ? "active" : ""}
                        onClick={() =>
                            // Keep route as show-interest to avoid breaking existing pages
                            handleTabClick("Watchlist", "show-interest")
                        }
                    >
                        Watchlist
                    </button>

                    {/* Manage Contracts */}
                    <button
                        className={activeTab === "Manage Contracts" ? "active" : ""}
                        onClick={() =>
                            handleTabClick("Manage Contracts", "manage-contract")
                        }
                    >
                        Manage Contracts
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VSNTransfers;


